import { addLead } from "../services/api.js";

document.addEventListener("DOMContentLoaded", () => {
    const enquireForm = document.getElementById("enquireForm");
    if (!enquireForm) return;

    const enquireName = document.getElementById("enquireName");
    const enquirePhone = document.getElementById("enquirePhone");
    const enquireLocation = document.getElementById("enquireLocation");

    enquireForm.addEventListener("submit", async (event) => {
        event.preventDefault();

        if (!validateForm()) return;

        const submitButton = enquireForm.querySelector("[type='submit']");
        submitButton.classList.add("loading");
        submitButton.innerHTML = "Loading...";

        const payload = {
            name: enquireName.value.trim(),
            mobilenumber: enquirePhone.value.trim(),
            location: enquireLocation.value.trim(),
        };

        setTimeout(() => {

            Swal.fire({
                text: "Form submitted successfully!",
                icon: "success",
                showConfirmButton: false,
                timer: 3000,
            });
            enquireForm.reset();
            submitButton.classList.remove("loading");
            submitButton.innerHTML = "Know More";
        }, 1000);

        // try {
        //     const res = await addLead(payload); // await API call
        //     console.log("API Response:", res);

        //     if (res) {
        //         Swal.fire({
        //             text: "Form submitted successfully!",
        //             icon: "success",
        //             showConfirmButton: false,
        //             timer: 3000,
        //         });
        //         enquireForm.reset();
        //     } else {
        //         throw new Error("Invalid response");
        //     }
        // } catch (error) {
        //     console.error("API Error:", error);
        //     Swal.fire({
        //         title: "Oops...",
        //         text: `${error?.response?.data?.issues?.message}` || "Something went wrong!",
        //         icon: "error",
        //         showConfirmButton: true,
        //     });
        // } finally {
        //     submitButton.classList.remove("loading");
        // }
    });

    // 🔁 Real-time validation
    enquireForm.addEventListener("input", (event) => {
        const target = event.target;
        if (target.tagName.toLowerCase() === "input") {
            validateField(target);
        }
    });

    // =========================
    // ✅ Validation Functions
    // =========================
    function validateForm() {
        let isValid = true;
        [enquireName, enquirePhone, enquireLocation].forEach((field) => {
            isValid = validateField(field) && isValid;
        });
        return isValid;
    }

    let fieldNameMap = {
        enquireName: "name",
        enquirePhone: "phone",
        enquireLocation: "location",
    };

    function validateField(field) {
        const fieldName = field.name;
        const fieldValue = field.value.trim();
        const errorSpan = document.getElementById(`${fieldName}Error`);
        const formControl = field.parentElement;

        errorSpan.textContent = "";
        formControl.classList.remove("error");

        if (!fieldValue) {
            errorSpan.textContent = `${capitalize(fieldNameMap[fieldName])} is required`;
            formControl.classList.add("error");
            return false;
        }

        if (fieldName === "enquireName" && !isValidName(fieldValue)) {
            errorSpan.textContent = "Invalid name";
            formControl.classList.add("error");
            return false;
        }

        if (fieldName === "email" && !isValidEmail(fieldValue)) {
            errorSpan.textContent = "Invalid email address";
            formControl.classList.add("error");
            return false;
        }

        if (fieldName === "enquirePhone" && !isValidMobile(fieldValue)) {
            errorSpan.textContent = "Invalid mobile number";
            formControl.classList.add("error");
            return false;
        }

        return true;
    }

    function isValidName(name) {
        return /^[a-zA-Z\s]{3,}$/.test(name);
    }

    function isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function isValidMobile(mobile) {
        return /^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/.test(mobile);
    }

    function capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
});
